import { useQuery, UseQueryResult } from '@tanstack/react-query-v4';
import { VellumProductsResponse } from '@scale/shared/types/vellum';
import { VellumCommunicationService } from './vellumCommunicationService';

// How to create a new query key https://tkdodo.eu/blog/effective-react-query-keys#effective-react-query-keys
const queryFactory = {
  vellum: {
    all: ['vellum'] as const,
    products: () => [...queryFactory.vellum.all, 'products'] as const,
    fetchProducts: () => ({
      queryKey: [...queryFactory.vellum.products()] as const,
      queryFn: () => VellumCommunicationService.fetchVellumProducts(),
    }),
  },
};

export const useVellumProducts = (): UseQueryResult<VellumProductsResponse> => {
  return useQuery<VellumProductsResponse>({
    ...queryFactory.vellum.fetchProducts(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
